module.exports = __webpack_public_path__ + "static/the-mouse-and-the-motorcycle-b551a88cc73ffab2a4be0297dc7ecc73.jpg";